export default {
  sports: [],
  tournaments: {},
  tournamentBetTemplates: {},
  bets: {},
  matches: {},
  isSelected: {
    offer: false,
    statistics: false,
  },
  selectedId: {
    sport: '',
    tournament: '',
    bet: '',
  },
  search: {
    tournament: '',
    bet: '',
    match: '',
  },
  copiedBets: [],
};
